import { groupBy } from 'lodash';
import { sortAlphaNum, sortAlphaNumByKey } from './sortAlphaNum';
import { ACCOUNT_HIERARCHY_LEVEL } from '@algomusinc/domain';
import { treeLevelHide } from './treeLevelHide';
export const CreateItemAccountTree = (
  accoutSettingList: any,
  accountList: any,
  selectable: boolean,
  expanded: boolean,
  nodeClass?: string
) => {
  const channelIds: any[] = [];
  const accoutSettingListTemp = accoutSettingList;
  accoutSettingList.forEach((account: any) => {
    if (channelIds.includes(account.channelId)) {
    } else {
      channelIds.push(account.channelId);
    }
  });
  let treeList: any[] = [];
  channelIds.forEach((channel) => {
    let currentChannel = accoutSettingList.find(
      (acc: any) => acc.channelId === channel
    );
    let channelObject: any = {
      label: currentChannel ? currentChannel.channelName : '',
      data: channel,
      children: [],
      icon: '',
      leaf: false,
      expanded: expanded,
      type: '',
      partialSelected: false,
      styleClass: nodeClass,
      draggable: false,
      droppable: false,
      selectable: selectable,
      key: `${channel}`,
      level: 1,
      isRoot: true,
    };
    const regionIds = accoutSettingListTemp
      .filter((el: any) => el.channelId === channel)
      .map((el: any) => el.continentId)
      .filter(
        (value: any, index: any, self: any) => self.indexOf(value) === index
      );
    regionIds.forEach((regionId: any) => {
      let currentRegion = accoutSettingList.find(
        (acc: any) => acc.continentId === regionId
      );
      let regionObject: any = {
        label: currentRegion ? currentRegion.continentName : '',
        data: regionId,
        children: [],
        icon: '',
        leaf: false,
        expanded: expanded,
        type: '',
        partialSelected: false,
        styleClass: nodeClass,
        draggable: false,
        droppable: false,
        level: 2,
        selectable: selectable,
        key: `${channel}${regionId}`,
      };
      const countryIds = accoutSettingListTemp
        .filter(
          (el: any) => el.continentId === regionId && el.channelId === channel
        )
        .map((el: any) => el.countryId)
        .filter(
          (value: any, index: any, self: any) => self.indexOf(value) === index
        );
      countryIds.forEach((countryId: any) => {
        let currentCountry = accoutSettingList.find(
          (acc: any) => acc.countryId === countryId
        );
        let countryObject = {
          label: currentCountry ? currentCountry.countryName : '',
          data: countryId,
          children: [],
          icon: '',
          leaf: false,
          expanded: expanded,
          type: '',
          partialSelected: false,
          styleClass: nodeClass,
          draggable: false,
          droppable: false,
          level: 3,
          selectable: selectable,
          key: `${channel}${regionId}${countryId}`,
        };
        let accounts = accountList.filter(
          (account: any) =>
            account.countryId === countryId &&
            account.regionId === regionId &&
            account.channelId === channel
        );
        accounts = accounts
          .map((element: any) => ({
            label: element.accountName,
            data: element.accountId || element.itemAccountId,
            children: [],
            icon: '',
            leaf: true,
            expanded: expanded,
            type: '',
            partialSelected: false,
            styleClass: nodeClass,
            draggable: false,
            droppable: false,
            level: 3,
            selectable: selectable,
            key: `${channel}${regionId}${countryId}${
              element.accountId || element.itemAccountId
            }`,
          }))
          .sort((a: any, b: any) => sortAlphaNumByKey(a, b, 'label'));
        countryObject.children = accounts;
        if (countryObject.children.length > 0) {
          regionObject.children.push(countryObject);
          regionObject.children = regionObject.children.sort((a: any, b: any) =>
            sortAlphaNumByKey(a, b, 'label')
          );
        }
      });
      if (regionObject.children.length > 0) {
        channelObject.children.push(regionObject);
        channelObject.children = channelObject.children.sort((a: any, b: any) =>
          sortAlphaNumByKey(a, b, 'label')
        );
      }
    });
    if (channelObject.children.length > 0) {
      treeList.push(channelObject);
      treeList = treeList.sort((a: any, b: any) =>
        sortAlphaNumByKey(a, b, 'label')
      );
    }
  });

  return treeList;
};
export const manipulateAccountHierarchy = (
  accountList: Array<any>,
  selectable: boolean,
  expanded: boolean,
  nodeClass?: string,
  showLeaf?: boolean
) => {
  // let isLevelHide = false;
  accountList = accountList.map((row) => {
    return {
      ...row,
      parentId: row.parentId ? row.parentId : null,
    };
  });
  const grouped = groupBy(accountList, (account) => account.parentId);

  function childrenOf(parentId: any): any {
    return (grouped[parentId] || []).map((account) => {
      return {
        parentId: account.parentId ? account.parentId : null,
        label: account.description,
        data: account.id,
        key: account.parentId
          ? `${account.parentId}${account.id}`
          : `${account.id}`,
        icon: '',
        isRoot: account.position == 1 ? true : false,
        leaf: account.key ? true : false,
        expanded: expanded,
        partialSelected: false,
        styleClass: nodeClass,
        draggable: true,
        droppable: false,
        selectable: selectable,
        level: account.position,
        children: childrenOf(account.id),
        metaData: account,
        partnerType: account.partnerType ? account.partnerType : '',
        isHidden: account.isHidden,
        distributoR_SFID: account.key,
      };
    });
  }
  function alphabeticSort(accountList: any) {
    if (accountList) {
      if (accountList['children'] && accountList['children'].length > 0) {
        accountList['children'].forEach((child: any) => alphabeticSort(child));
      }
      accountList.children.sort((a: any, b: any) =>
        sortAlphaNumByKey(a, b, 'label')
      );
      return accountList;
    }
  }
  accountList = childrenOf(null);
  accountList = treeLevelHide(accountList, showLeaf);
  if (!showLeaf) {
    let treeList = {
      children: accountList,
    };
    treeList = alphabeticSort(treeList);
    accountList = treeList['children'];
  } else {
    accountList.forEach((child: any) => alphabeticSort(child));
  }
  return accountList;
};

// export const manipulateCalendarHierarchy = (accountList: Array<any>, selectable: boolean, expanded: boolean, nodeClass?: string, showLeaf?:boolean) => {
//   let isLevelHide = false;
//   accountList = accountList.map((row) => {
//     return {
//       ...row,
//       parentId: row.parentId ? row.parentId : null,
//     };
//   });
//   const grouped = groupBy(
//     accountList,
//     (account) => account.parentId
//   );

//   function childrenOf(parentId: any): any {
//     return (grouped[parentId] || []).map((account) => {
//       return {
//         parentId: account.parentId ? account.parentId : null,
//         label: account.description,
//         data: account.id,
//         key: account.parentId ? `${account.parentId}${account.id}`: `${account.id}`,
//         icon: '',
//         isRoot: account.position == 1 ? true : false,
//         // leaf: account.key ? true: false,
//         leaf: account.name == 'Leaf' ? true: false,
//         expanded: expanded,
//         partialSelected: false,
//         styleClass: nodeClass,
//         draggable: true,
//         droppable: false,
//         selectable: selectable,
//         level: account.position,
//         children: childrenOf(account.id),
//         metaData: account,
//         partnerType: account.partnerType ? account.partnerType : '',
//         isHidden : account.isHidden
//       }
//     })
//   }
//   function alphabeticSort(accountList:any){
//     if(accountList["children"] && accountList["children"].length > 0){
//       if(!isLevelHide && accountList.isHidden){
//         isLevelHide = true;
//       }
//       accountList["children"].forEach ((child: any) => alphabeticSort(child));
//       accountList.children.sort((a: any, b: any) => sortAlphaNumByKey(a,b, 'label'));
//       return accountList;
//     }
//   }
//   accountList = childrenOf(null);
//     accountList.forEach ((child: any) => alphabeticSort(child));
//     if(isLevelHide || !showLeaf){
//       accountList = treeLevelHide(accountList,showLeaf);
//     }
//     return accountList;
// }
export const HideTreeNode = (treeData: any, showLeaf: boolean) => {
  function alphabeticSort(tree: any) {
    if (tree) {
      if (tree['children'] && tree['children'].length > 0) {
        tree['children'].forEach((child: any) => alphabeticSort(child));
      }
      tree.children.sort((a: any, b: any) => sortAlphaNumByKey(a, b, 'label'));
      return tree;
    }
  }
  treeData = treeLevelHide(treeData, showLeaf);
  if (!showLeaf) {
    let treeList = {
      children: treeData,
    };
    treeList = alphabeticSort(treeList);
    treeData = treeList['children'];
  } else {
    treeData.forEach((child: any) => alphabeticSort(child));
  }
  return treeData;
};
